module.exports = __webpack_public_path__ + "static/media/color-flower.d3ca3531.svg";